export const requests = (requestConfig, instance) => {
    return instance.request({ ...requestConfig, url: requestConfig.path }).then(responseBody)
};

const responseBody = (response) => response?.data;